import { inject, Injectable } from '@angular/core';

import { IMessageListData, MessageListData } from '../models/message-list-data';
import { IMessageListDto } from 'src/assets/common/models/message-list-dto.g';
import { LoadingService } from 'src/app/infrastructure/services/loading-services/_loading.service';
import { TabListService } from '../../shared/central-page/services/tab-list.service';
import { _ListService } from 'src/app/infrastructure/services/list-services/_list.service';
import { tabName } from 'src/app/infrastructure/services/page-services/models/tab-name';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable()
export class MessageListService
    extends _ListService<IMessageListDto, IMessageListData>
{
    protected override readonly _loadingService = injectRequired(LoadingService);
    protected override readonly _tabListService = inject(TabListService, { optional: true });

    override listActive$ = this._listActive$;
    override hasDeletedList$$ = this._hasDeletedList$$;
    override hasInactiveList$$ = this._hasInactiveList$$;
    override listActive$$ = this._listActive$$;
    override listAll$$ = this._listAll$$;
    override listDeleted$$ = this._listDeleted$$;
    override listDeletedAll$$ = this._listDeletedAll$$;
    override listInactive$$ = this._listInactive$$;

    override listName = tabName.projectMessages;

    override list_refresh$ = this._list_refresh$;

    override list_load$ = this._list_load$;

    override listData_load(listDto: IMessageListDto): IMessageListData | null {
        return MessageListData.create(listDto);
    }
}
